const InspectionsTypes = {
  FETCH_INSPECTION_BY_ID_REQUEST: 'inspections/FETCH_INSPECTION_BY_ID_REQUEST',
  FETCH_INSPECTION_BY_ID_SUCCESS: 'inspections/FETCH_INSPECTION_BY_ID_SUCCESS',
  FETCH_INSPECTION_BY_ID_ERROR: 'inspections/FETCH_INSPECTION_BY_ID_ERROR',

  CLEAR_CURRENT_INSPECTION: 'inspections/CLEAR_CURRENT_INSPECTION',
};

export default InspectionsTypes;
